import React from 'react';

export default () => {
    return (
        <p>Hi this is PaymentSearch.Home</p>
    )
}